// Keep the native Horizon filters mounted, so hiding them never clears selected facets.
const storageKey = 'sons-filters-collapsed';

try {
  if (sessionStorage.getItem(storageKey) === 'true') {
    document.documentElement.dataset.sonsFiltersCollapsed = 'true';
  }
} catch {
  // Storage may be disabled; the toggle still works for the current page.
}

const syncButtons = () => {
  const expanded = document.documentElement.dataset.sonsFiltersCollapsed !== 'true';

  for (const button of document.querySelectorAll('[data-sons-filters-toggle]')) {
    if (button.getAttribute('aria-expanded') !== String(expanded)) {
      button.setAttribute('aria-expanded', String(expanded));
    }
  }
};

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || !event.target.closest('[data-sons-filters-toggle]')) return;

  const collapsed = document.documentElement.dataset.sonsFiltersCollapsed !== 'true';
  document.documentElement.dataset.sonsFiltersCollapsed = String(collapsed);

  try {
    sessionStorage.setItem(storageKey, String(collapsed));
  } catch {
    // Preserve interaction even when storage cannot be used.
  }

  syncButtons();
});

// Shopify re-renders the filters after a facet is selected; restore the button's ARIA state.
const observer = new MutationObserver((mutations) => {
  if (
    mutations.some(
      (mutation) =>
        (mutation.type === 'attributes' && mutation.target.matches?.('[data-sons-filters-toggle]')) ||
        (mutation.type === 'childList' && [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('[data-sons-filters-toggle]') || node.querySelector?.('[data-sons-filters-toggle]'))))
    )
  ) {
    syncButtons();
  }
});

observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
syncButtons();
